import { render, staticRenderFns } from "./address-street.vue?vue&type=template&id=da8ad054&scoped=true&"
import script from "./address-street.vue?vue&type=script&lang=js&"
export * from "./address-street.vue?vue&type=script&lang=js&"
import style0 from "./address-street.vue?vue&type=style&index=0&id=da8ad054&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da8ad054",
  null
  
)

export default component.exports